import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import iconUpgrade from '@src/assets/images/icon-paid-package.png';
import { PACKAGE_LEVEL_V3, PACKAGE_TYPE } from '@src/constants/package';
import { useMappingPackage } from '@src/hooks/useMappingPackage';
import usePaywallTracking from '@src/hooks/usePaywallTracking';
import { MOE_PAYWALL_CTA, MOE_PAYWALL_TYPE } from '@src/constants/moengage';

const OutOfCreditsSpecial = ({ open, onClose, voice = {} }) => {
  const { getUpgradePackageCode, packages } = useMappingPackage();
  const { usingPackage } = useSelector((state) => state.user);
  const { type, expiresIn } = usingPackage || {};
  const eolVoice = voice?.eolDate;
  const { t } = useTranslation();
  const history = useHistory();
  const { trackCta } = usePaywallTracking({
    paywallType: MOE_PAYWALL_TYPE.OUT_OF_CREDITS,
  });

  const handleBuyMore = () => {
    const topupPackageCode = packages.find(
      (p) =>
        p.type === PACKAGE_TYPE.STUDIO &&
        p.level === PACKAGE_LEVEL_V3.SPECIAL &&
        p.isTopUp,
    )?.code;
    trackCta(MOE_PAYWALL_CTA.TOPUP, { targetPackageCode: topupPackageCode });
    const url = `${ROUTES.PAYMENT}?package=${topupPackageCode}`;
    history.push(url);
  };

  const handleUpgradeVIP = () => {
    // Resolve the VIP package for the current duration (version-agnostic). Fall
    // back to the generic payment page only if none exists.
    const upgradePackage = getUpgradePackageCode({
      type,
      expiresIn,
      targetLevel: PACKAGE_LEVEL_V3.VIP,
    });
    trackCta(MOE_PAYWALL_CTA.UPGRADE, { targetPackageCode: upgradePackage });
    const url = upgradePackage
      ? `${ROUTES.PAYMENT}?package=${upgradePackage}`
      : ROUTES.PAYMENT;
    history.push(url);
  };

  const renderBuyMoreButton = () => {
    if (eolVoice) {
      return (
        <>
          <Button variant="contained" onClick={onClose}>
            {t('gotIt')}
          </Button>
          <Button className="outlined-button" onClick={handleUpgradeVIP}>
            {t('upgradePackage')}
          </Button>
        </>
      );
    }

    return (
      <Button variant="contained" onClick={handleBuyMore}>
        {t('buyMoreChar')}
      </Button>
    );
  };

  const renderDescription = () => {
    if (eolVoice) {
      return t('descriptionOutOfCreditsStandardEOL');
    }
    return t('descriptionOutOfCreditsSpecial');
  };

  return (
    <NotificationDialogV4
      image={iconUpgrade}
      title={t('outOfCredits')}
      description={renderDescription()}
      actionComponent={renderBuyMoreButton()}
      open={open}
      onClose={onClose}
    />
  );
};

export default OutOfCreditsSpecial;
